
import { Component, Vue } from "vue-property-decorator";
import { IInventoryPlanModel } from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import ConfirmInventoryPlan from "./components/ConfirmInventoryPlan.vue";
import { queryInventoryPlans } from "@/api/inventory-plan";
@Component({
  name: "InventoryPlanManagement",
  components: {
    Pagination,
    ConfirmInventoryPlan,
  },
})
export default class extends Vue {
  private tableKey = 0;
  private inventoryPlanModels: IInventoryPlanModel[] = [];
  private total = 0;
  private listLoading = true;
  private showConfirm = false;
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    keyword: null,
    state: [],
  };

  private inventoryPlanStates = {
    TO_BE_COMPLETED: "待盘库",
    COMPLETED: "已盘库",
  };

  // private dialogStatus = "";
  // private actionName = {
  //   writeInformation: "填写信息",
  //   updateStorageLayers: "移动库区"
  // };

  private payload = new InventoryPlanInput();

  created() {
    this.initData();
  }

  private getHiddenColumns() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("actionColumns");
    }
  }

  private async initData() {
    this.listQuery.pageNumber = 1;
    await this.getList();
  }

  private async  handleFilter() {
    this.listQuery.pageNumber = 1;
    await this.getList();
  }

  private async getList() {
    this.listLoading = true;
    const params = Object.assign({}, this.listQuery);
    await queryInventoryPlans(params).then((res:any) => {
      const { total, content }: any = res
      this.total = total;
      this.inventoryPlanModels = content;
      this.listLoading = false;
    }).catch(err => {
      console.log(err);
      this.listLoading = false;
    });
  }

  private gotoImageManagementPage(row: IInventoryPlanModel) {
    this.$router.push({
      name: "ImageManagement",
      params: { bizType: "inventory-plan", objectId: row.id },
    });
  }

  private checkDetail(row: IInventoryPlanModel) {
    this.$router.push({
      name: "InventoryPlanDetail",
      params: { inventoryPlanId: row.id },
    });
  }
  private confirmRow: IInventoryPlanModel;
  private confirmType: string;
  private currentTitle: string;

  private checkConfirm(row: IInventoryPlanModel, type: string, title: string) {
    this.confirmRow = row;
    this.confirmType = type;
    this.currentTitle = title;
    this.showConfirm = true;
  }
}

class InventoryPlanInput {
  id: string;
  deliveryNoteCode: string;
  storageLayerNames: string;
  createAt: string;
  state: string;
}
